import Template from './template';
import Information from './information';
import CreateStoreFront from './CreateStoreFront';

export default {
  Information,
  Template,
  CreateStoreFront,
};
